// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ourTakeWrapper":"_151y0z","banner":"_2ZZhqC"};